import React, { useState, useCallback } from 'react';
import { BackgroundIcon } from '@nile/components';
import Conf from '@nile/home/src/Config/env';
import styled from 'styled-components';
import { SVGIcon } from '@superops/super-icons';
import { DisplayText } from '@superops/ui-design-system';
import AddAttachments from './EditorAddAttachment';

const CustomPopUpContent = styled.div`
  display: ${({ active }) => (active ? 'block' : 'none')};
  position: absolute;
  background-color: white;
  border-radius: 4px;
  bottom: 100%;
  padding: 10px 15px;
  border: 1px solid #f5f5f5;
  box-shadow: 0px 2px 20px rgba(0, 0, 0, 0.05);
  z-index: 1;
  width: max-content;
  margin-bottom: 6px;

  .ql-size.ql-picker {
    width: 70px !important;
  }
`;

const CustomTextEditorIcons = styled.span`
  cursor: pointer;
  svg {
    background-color: ${({ active }) =>
      active ? 'rgba(0,0,0,0.1)' : 'transparent'};
    border-radius: 2px;
    padding-left: 4px;
    padding-right: 4px;
    width: 34px;
  }
`;

const CustomToolbarGroupIcons = (props) => {
  const [active, setActive] = useState(false);
  const [showAlignText, setShowAlignText] = useState(false);

  const toggleActive = useCallback(() => {
    if (showAlignText) {
      setShowAlignText(false);
    }
    setActive((active) => !active);
  }, [showAlignText]);

  const toggleAlignmentActive = useCallback(() => {
    if (active) {
      setActive(false);
    }
    setShowAlignText((showAlignText) => !showAlignText);
  }, [active]);

  return (
    <div id={`toolbar${props?.randomToolbarKey}`} className="ql-toolbar">
      {/* <select className="ql-font" /> */}
      <span className="position-relative float-left">
        <CustomTextEditorIcons onClick={toggleActive} active={active}>
          <SVGIcon name="TextFormatting" size="lg" />
        </CustomTextEditorIcons>
        <CustomPopUpContent active={active}>
          <div className="mb6">
            <DisplayText variation="subdued">TEXT DECORATIONS</DisplayText>
          </div>
          <span className="d-in mr8">
            <select className="ql-size">
              <option value="10px" selected>
                10px
              </option>
              <option value="11px">11px</option>
              <option value="12px">12px</option>
              <option value="13px">13px</option>
              <option value="14px">14px</option>
              <option value="15px">15px</option>
              <option value="16px">16px</option>
              <option value="17px">17px</option>
              <option value="18px">18px</option>
              <option value="19px">19px</option>
              <option value="20px">20px</option>
              <option value="21px">21px</option>
              <option value="22px">22px</option>
              <option value="23px">23px</option>
              <option value="24px">24px</option>
            </select>
          </span>
          <span className="d-in mr8">
            <select className="ql-color" />
          </span>
          <span className="d-in mr8">
            <button className="ql-bold" />
          </span>
          <span className="d-in mr8">
            <button className="ql-italic" />
          </span>
          <span className="d-in">
            <button className="ql-underline" />
          </span>
        </CustomPopUpContent>
      </span>
      <span className="position-relative float-left">
        <CustomTextEditorIcons
          onClick={toggleAlignmentActive}
          active={showAlignText}
        >
          <SVGIcon name="Alignment" size="lg" />
        </CustomTextEditorIcons>
        <CustomPopUpContent active={showAlignText}>
          <div className="mb6">
            <DisplayText variation="subdued">TEXT ALIGNMENT</DisplayText>
          </div>
          <button class="ql-align" value=""></button>
          <button class="ql-align" value="center"></button>
          <button class="ql-align" value="right"></button>
          <button class="ql-align" value="justify"></button>
        </CustomPopUpContent>
      </span>
      {/* <select className="ql-align" /> */}
      <button className="ql-list" value="bullet" />
      <button className="ql-list" value="ordered" />
      {props?.showInlineImage && <button className="ql-image" />}
      <button className="ql-link" />
      <button className="ql-emoji">
        <BackgroundIcon url={`url(${Conf.imageRoot}svg/Emojies.svg)`} />
      </button>
      {props?.handleFileAttachments && <AddAttachments {...props} />}
    </div>
  );
};

export default CustomToolbarGroupIcons;
